// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScheduledReports_wrapper__UYw6s"};